export default __webpack_public_path__ + "static/media/photo.040b2e92.svg";